module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.job_no ||
        _vm.Filter.commonFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.airLineFilter ||
        _vm.Filter.airportDepartureFilter ||
        _vm.Filter.airportDestinationFilter ||
        _vm.Filter.transportFilter ||
        _vm.Filter.jobTypeFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.isShipmentFilter ||
        _vm.Filter.isActiveFilter ||
        _vm.Filter.isDeletedFilter ||
        _vm.Filter.dateRange.startDate ||
        _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.job_no ||
    _vm.Filter.commonFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.airLineFilter ||
    _vm.Filter.airportDepartureFilter ||
    _vm.Filter.airportDestinationFilter ||
    _vm.Filter.transportFilter ||
    _vm.Filter.jobTypeFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.isShipmentFilter ||
    _vm.Filter.isActiveFilter ||
    _vm.Filter.isDeletedFilter ||
    _vm.Filter.dateRange.startDate ||
    _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getAirList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getAirList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getAllTPTCCAirList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getAllTPTCCAirList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("AirLine")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirLineList'],
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select Air Line"
    },
    on: {
      "input": function($event) {
        _vm.getAllTPTCCAirList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.airLineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "airLineFilter", $$v)
      },
      expression: "Filter.airLineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Departure")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirPortDepartureList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport of Departure"
    },
    on: {
      "input": function($event) {
        _vm.getAllTPTCCAirList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.airportDepartureFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "airportDepartureFilter", $$v)
      },
      expression: "Filter.airportDepartureFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Destination")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirPortDestinationList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport of Destination"
    },
    on: {
      "input": function($event) {
        _vm.getAllTPTCCAirList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.airportDestinationFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "airportDestinationFilter", $$v)
      },
      expression: "Filter.airportDestinationFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.TransportTypeList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.getAllTPTCCAirList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.transportFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "transportFilter", $$v)
      },
      expression: "Filter.transportFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.JobTypeList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.getAllTPTCCAirList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.jobTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "jobTypeFilter", $$v)
      },
      expression: "Filter.jobTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Job No Filter",
      "id": "job_no",
      "name": "job_no",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getAllTPTCCAirList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.job_no),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "job_no", $$v)
      },
      expression: "Filter.job_no"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Subject Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getAllTPTCCAirList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getAllTPTCCAirList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getAirList,
      "fields": _vm.JobsFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "JobNo",
      fn: function(row1) {
        return [_c('span', [_c('a', {
          staticClass: "job-no",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              row1.item.is_locked == '1' &&
                (row1.item.finalBillingCompleted == 1 ||
                  row1.item.locked_counter > 0) &&
                _vm.$sessionsStorage.get('designation') != 'Admin' &&
                _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
                '' :
                _vm.handleJobClick(row1.item.JobNo, row1.item)
            }
          }
        }, [_c('b', [_vm._v("Job No: ")]), _vm._v(_vm._s(row1.item.JobNo) + "\n                  ")])]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Job Date : ")]), _vm._v(_vm._s(row1.item.created_at))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Job Type : ")]), _vm._v(_vm._s(row1.item.air_ct_job_type))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Transport Type : ")]), _vm._v(_vm._s(row1.item.air_ct_transport_type))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Shipment Type : ")]), _vm._v(_vm._s(row1.item.air_ct_shipment_type_Txt))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Enq No : ")]), _vm._v(_vm._s(row1.item.EnqNo))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Enq Date : ")]), _vm._v(_vm._s(row1.item.EnqDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Booking No : ")]), _vm._v(_vm._s(row1.item.booking_no))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Raised By : ")]), _vm._v(_vm._s(row1.item.CreatedBy))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Raised From : ")]), _vm._v(_vm._s(row1.item.RaisedBy))]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": row1.item.is_locked == '1' &&
              (row1.item.air_ct_main_sales_execution_relation.finalBillingCompleted == 1 || row1.item.locked_counter > 0) ?
              'danger' :
              'success'
          },
          on: {
            "click": function($event) {
              row1.item.is_locked == '1' &&
                (row1.item.air_ct_main_sales_execution_relation.finalBillingCompleted == 1 || row1.item.locked_counter > 0) ?
                _vm.LockUnLock(row1.item, 'locked') :
                ''
            }
          }
        }, [(
          row1.item.is_locked == '1' &&
          (row1.item.air_ct_main_sales_execution_relation.finalBillingCompleted == 1 ||
            row1.item.locked_counter > 0)
        ) ? _c('b', [_c('i', {
          staticClass: "fa fa-lock mr-1 lg"
        }), _vm._v("LOCKED")]) : _c('b', [_c('i', {
          staticClass: "fa fa-unlock mr-1 lg"
        }), _vm._v("UN-LOCKED")])]), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('Overseas-CRDRNote', {
          attrs: {
            "title": row1.item.JobNo,
            "moduleType": 'Air ' + row1.item.air_ct_transport_type + ' Module',
            "cr_all_module_id": String(row1.item.fk_all_module_id),
            "cr_jb_series": row1.item.JobNo,
            "cr_ass_date": row1.item.loginTime,
            "transportType": row1.item.air_ct_transport_type,
            "Jobtype": _vm.$route.path == '/airImport/viewAirCC' ? 'CC' : 'TPT',
            "commonId": String(row1.item.air_ct_id),
            "shipmentType": row1.item.air_ct_shipment_type == '2' ? 'Air' : 'Sea',
            "isOverseas": false,
            "ItemAr": null
          }
        }), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row1.item.fk_all_module_id,
            "jb_series": row1.item.JobNo
          }
        }), _vm._v(" "), (row1.item.fk_all_module_id) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.fk_all_module_id.toString(),
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.fk_all_module_id) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.fk_all_module_id.toString(),
            "PMC_JOBNO": row1.item.JobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e()]
      }
    }, {
      key: "ClientName",
      fn: function(row5) {
        return [_c('span', [_c('b', [_vm._v("Client : ")]), _vm._v(_vm._s(row5.item.ClientName))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Exp Client : ")]), _vm._v(_vm._s(row5.item.ExpClientName))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Imp Client : ")]), _vm._v(_vm._s(row5.item.ImpClientName))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Airline : ")]), _vm._v(_vm._s(row5.item.Airline))]), _c('br')]
      }
    }, {
      key: "Departure",
      fn: function(row5) {
        return [_c('span', [_c('b', [_vm._v("Departure : ")]), _vm._v(_vm._s(row5.item.Departure))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Destination : ")]), _vm._v(_vm._s(row5.item.Destination))])]
      }
    }, {
      key: "air_ct_flight_no",
      fn: function(row5) {
        return [_c('span', [_c('b', [_vm._v("Flight No : ")]), _vm._v(_vm._s(row5.item.air_ct_flight_no))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Flight Date : ")]), _vm._v(_vm._s(row5.item.FlightDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Bl Type : ")]), _vm._v(_vm._s(row5.item.air_ct_bl_type))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("MAWB/Bl No : ")]), _vm._v(_vm._s(row5.item.air_ct_mawb_bl_number))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("MAWB/Bl Date : ")]), _vm._v(_vm._s(row5.item.MAWBDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("AWB/Bl No : ")]), _vm._v(_vm._s(row5.item.air_ct_awb_bl_number))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("AWB/Bl Date : ")]), _vm._v(_vm._s(row5.item.AWBDate))])]
      }
    }, {
      key: "air_ct_shipping_bl_no",
      fn: function(row5) {
        return [_c('span', [_c('b', [_vm._v("Shipping Bl No : ")]), _vm._v(_vm._s(row5.item.air_ct_shipping_bl_no))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Shipping Bl Date : ")]), _vm._v(_vm._s(row5.item.ShippingBLdate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Shipping Inv No : ")]), _vm._v(_vm._s(row5.item.air_ct_shipper_inv_no))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Shipping Inv Date : ")]), _vm._v(_vm._s(row5.item.ShippingInvdate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Clearance Date : ")]), _vm._v(_vm._s(row5.item.ClearanceDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Handover date : ")]), _vm._v(_vm._s(row5.item.HandDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Booking Date : ")]), _vm._v(_vm._s(row5.item.BookingDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Departure Date : ")]), _vm._v(_vm._s(row5.item.DepartureDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Arrival Date : ")]), _vm._v(_vm._s(row5.item.ArrivalDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Expected Departure Date : ")]), _vm._v(_vm._s(row5.item.ExpectedDepartureDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Expected Arrival Date : ")]), _vm._v(_vm._s(row5.item.ExpectedArrivalDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Actual Departure Date : ")]), _vm._v(_vm._s(row5.item.ActualDepartureDate))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Actual Arrival Date : ")]), _vm._v(_vm._s(row5.item.ActualArrivalDate))])]
      }
    }, {
      key: "air_ct_cargo_gross_weight",
      fn: function(row5) {
        return [_c('span', [_c('b', [_vm._v("Cargo Gross Wgt. : ")]), _vm._v(_vm._s(row5.item.air_ct_cargo_gross_weight))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Cargo Net Wgt. : ")]), _vm._v(_vm._s(row5.item.air_ct_cargo_net_weight))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Volume Wgt. : ")]), _vm._v(_vm._s(row5.item.air_ct_cargo_volume_weight))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Pkg Type : ")]), _vm._v(_vm._s(row5.item.air_ct_cargo_pkg_type))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Unit : ")]), _vm._v(_vm._s(row5.item.air_ct_cargo_unit))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Chargeable Wgt. By Sys : ")]), _vm._v(_vm._s(row5.item.air_ct_chargeable_weight_by_sys))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Chargeable Wgt. By Airline : ")]), _vm._v(_vm._s(row5.item.air_ct_chargeable_weight_by_airline))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Chargeable Wgt. Final : ")]), _vm._v(_vm._s(row5.item.air_ct_chargeable_weight_final))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Total Pkg : ")]), _vm._v(_vm._s(row5.item.air_ct_tot_pkg))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Pkg Length : ")]), _vm._v(_vm._s(row5.item.air_ct_length_pkg))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Pkg Width : ")]), _vm._v(_vm._s(row5.item.air_ct_width_pkg))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Pkg Height : ")]), _vm._v(_vm._s(row5.item.air_ct_height_pkg))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Pkg Unit : ")]), _vm._v(_vm._s(row5.item.air_ct_unit_pkg))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Pkg Volume : ")]), _vm._v(_vm._s(row5.item.air_ct_volume_pkg))]), _c('br')]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "modal-lock-conf",
    attrs: {
      "id": "modal-lock-conf",
      "title": "Reason for Open Locked Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.lockReason),
      callback: function($$v) {
        _vm.lockReason = $$v
      },
      expression: "lockReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeLockUnLockConfirm
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), (_vm.lockReason) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.lock_button ? true : false,
      "variant": "success"
    },
    on: {
      "click": _vm.ConfLock
    }
  }, [_vm._v("Send")]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c9e2482","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airFreight/viewAirCCTPT.vue
// module id = 2814
// module chunks = 0